module.exports = __webpack_public_path__ + "static/media/SLOTS@3x.6a196247.png";